import script from "./FileCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./FileCarousel.vue?vue&type=script&setup=true&lang=js"

import "./FileCarousel.vue?vue&type=style&index=0&id=df86f1fa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df86f1fa"]])

export default __exports__